<template>
    <h1>{{ $t('menu.retailSupportProgram.page.header') }}</h1>
</template>